import "driver.js/dist/driver.css";

import { bootTours } from "./tours/runtime";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    bootTours();
  });
} else {
  bootTours();
}
